import styled from '@emotion/styled'

import { HelpIcon, TooltipText } from '../../../components'

const InlineIcon = styled(HelpIcon)`
  margin-left: 8px;
  line-height: 0;
  /* Nudge the icon to visually align with the text. */
  vertical-align: 0.09em;
`

const CouldYouLiveHelp = () => (
  <InlineIcon size='custom18' tooltip={TooltipText.couldYouLiveOnThis()} />
)

export default CouldYouLiveHelp
